import React from 'react';
import {Container, Card, Row, Col} from 'react-bootstrap';

/**
 * @description раздел с проектами компании
 * @returns {Element}
 * @constructor
 */
function Projects() {
    return (
        <Container>
            <h1>Проекты</h1>
            <br/>
            <hr/>
            <br/>
            <Row>
                <Col key={0} xs={12} sm={12} md={12} lg={12} className="mb-4">
                    <Card>
                        <Card.Body>
                            <Card.Title>{"Skillblocks"}</Card.Title>
                            <Card.Text>{"Платформа для эффективного обучения с автоматической модерацией контента: каждый курс проходит проверку на корректность структуры и полноту материалов перед публикацией; система поддерживает актуальность программ - авторы могут обновлять курсы, а алгоритм помечает устаревшие; сервис ориентирован на удобство пользователей - мы анализируем обратную связь и внедряем востребованные функции, чтобы обучение было комфортным и результативным."}</Card.Text>
                        </Card.Body>
                        <Card.Body>
                            <Card.Link href={"https://skillblocks.ru"}>подробнее</Card.Link>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default Projects;
